import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthLoginRequest = object('AuthLoginRequest', {
  tenant: string(),
  realm: string(),
  provider: string(),
  username: string(),
  password: string(),
});
